import React from 'react';
import { TextField, TextFieldProps } from 'src/components/TextField';
import s from './TextArea.styles';

export type TextAreaProps = TextFieldProps;

export const TextArea: React.FC<TextAreaProps> = props => (
  <TextField numberOfLines={4} {...props} rootStyle={s.root} multiline={true} />
);
